import React from 'react'
import PersonIcon from '@mui/icons-material/Person'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import { applyMask } from '@/services/utils'

export type BorrowerPreviewCardProps = {
	title: string
	name?: string | null
	phone?: string | null
	email?: string | null
}

function BorrowerPreviewCard({
	title,
	name,
	phone,
	email,
}: BorrowerPreviewCardProps) {
	return (
		<div className="p-4 border border-[#E0E0E0] rounded-md md:max-w-64 lg:max-w-none">
			<h3 className="text-sm font-bold mb-2">{title}</h3>
			<p className="flex items-center gap-2 mb-1">
				<PersonIcon fontSize="inherit" />
				{name}
			</p>
			{email && (
				<p className="flex items-center gap-2 mb-1">
					<EmailIcon fontSize="inherit" />
					<a className="underline break-all" href={`mailto:${email}`}>
						{email}
					</a>
				</p>
			)}
			{phone && (
				<p className="flex items-center gap-2">
					<PhoneIcon fontSize="inherit" />
					<a className="underline" href={`tel:${phone}`}>
						{applyMask(phone, 'phone')}
					</a>
				</p>
			)}
		</div>
	)
}

export default BorrowerPreviewCard
